/* envirotokens-vote.js */

(function($) {
	
	$('.et_checks').each(function(){
		var $ref = $(this);
		var max_limit = 5;
		if($ref.parent().hasClass('et_cat')){
			max_limit = 2;
		}
		$ref.find("input:checkbox").on("change", function () {
			if($ref.find("input:checkbox:checked").length > max_limit){
				this.checked = false;
			}
		});		
	});
	$('#et_form').on("submit", function(e){
		e.preventDefault();
		$(this).find(':input.required').each(function(){
			if(!$(this).val() || ($(this).is(":checkbox") && !$(this).is(":checked"))){
				$(this).parent().addClass('err');
			}else{
				$(this).parent().removeClass('err');
			}
		});
		if($(".et_checks input:checkbox:checked").length < 1){
			$('.et_fields').addClass('err');
		}else{
			$('.et_fields').removeClass('err');
		}
		
		if($(this).find('.err').length>0){
			return false;
		}

		var org = 1;
		var data = {};

		$('#et_form *').filter(':input').each(function () {
			var name = $(this).attr('name');
			var val = $(this).val();

			if (name == "votes[]") {
				if ($(this).is(":checked")) {
					data['Org_' + org] = val;
					org++;
				}
			} else if (name) {
				data[name] = val;
			}
		});
		console.log(["data", data]);

		$.ajax({
			type: "POST",
			url: "/api/envirotokensvote/vote",
			data: JSON.stringify(data),
			contentType: 'text/json',
			success: function (res) {
				console.log(["result", res], 'envirotokens back');
				if (res.success) {
					$('.et_holder h5').html(res.message);
				} else {
					$('.et_holder h5').html("Error recording vote, please try again.");
				}
			},
			error: function (data) {
				console.log(data);
			}
		});

		$('#et_form').slideUp();
		$('.et_holder h5').html('Processing...');
		window.scrollTo(0, 0);

	});
	
	

})(jQuery);